export const mossvoxOverview = {
  heroTitle: 'MossVox',
  heroSubtitle: 'AI 悬浮字幕 · 让每一次对话都可听可见',
  heroTag: 'AI 智能字幕产品线',
  heroDesc: 'MossVox 是新译科技推出的 AI 智能字幕产品线，涵盖字幕精灵 Pro（悬浮字幕翻译软件）和录音牌（转写录音硬件），覆盖音视频会议字幕翻译、通话实时字幕、录音转文字等全场景需求，让声音内容可听可见、可留存可追溯。',
  heroImageQuery: 'MossVox floating translation subtitle overlay on laptop screen during international video conference, compact MossVox voice recorder device next to laptop, software plus hardware ecosystem for speech to text, modern digital workspace with AI captioning technology, clean aesthetic, warm neutral tones, professional productivity photography',
  heroImageSeq: 'mossvox-overview-hero',
};

export const mossvoxProducts = [
  {
    id: 'subtitle-pro',
    title: '字幕精灵 Pro',
    subtitle: 'AI 悬浮字幕翻译软件',
    desc: '悬浮字幕翻译工具，深度适配 Zoom、Teams、Google Meets、微信语聊、AirPods 通话等所有主流音视频平台。实时语音识别 + AI 翻译，字幕悬浮显示，支持 140+ 语种单向及双向互译，让跨境会议、外语网课、跨国通话无障碍沟通。',
    features: ['全平台适配', '140+语种', '双向互译', '悬浮显示'],
    href: '/mossvox/subtitle-pro',
    imageQuery: 'MossVox subtitle pro AI translation software interface with floating semitransparent captions overlay on Zoom video conference screen, real time Chinese English bilingual subtitles during meeting, 140 plus language support visible, clean modern digital workspace, soft studio lighting, minimalist tech aesthetic',
    imageSeq: 'subtitle-pro-card',
  },
  {
    id: 'recorder',
    title: '录音牌',
    subtitle: 'AI 转写录音硬件',
    desc: '专为通话转写设计的便携录音硬件。IP67 防水防尘、7m 远距离拾音、70 天超长待机、20 小时连续录音。适配微信/WhatsApp/VoIP/LINE 等所有通话工具，录音自动转文字 + AI 生成发言稿。本地存储，数据保密安全。',
    features: ['IP67防水', '7m拾音', '70天待机', '本地存储'],
    href: '/mossvox/recorder',
    imageQuery: 'MossVox compact voice recorder hardware device on modern desk next to smartphone showing call recording transcription result, AI speech to text recording gadget with IP67 waterproof 7 meter pickup 70 day standby features, sleek minimal design, professional product photography, studio lighting, warm neutral tones',
    imageSeq: 'recorder-card',
  },
];

export const mossvoxEcosystem = {
  title: '可听可见 · 全场景字幕方案',
  subtitle: '字幕精灵 Pro（软件）+ 录音牌（硬件），覆盖线上会议与线下通话',
  desc: 'MossVox 采用软硬结合的产品策略：字幕精灵 Pro 面向音视频会议场景，悬浮字幕翻译覆盖所有主流平台；录音牌面向通话转写场景，硬件录音 + AI 转写确保信息不遗漏。两者均可独立使用，组合使用实现全场景声音数字化。',
  points: [
    { icon: 'ri-computer-line', title: '字幕精灵 Pro', desc: '软件端悬浮字幕翻译，覆盖Zoom/Teams/Meets/微信/电话全平台' },
    { icon: 'ri-mic-line', title: '录音牌', desc: '硬件端通话录音转写，IP67级防护，7m拾音，70天超长待机' },
  ],
};

export const subtitleProData = {
  banner: {
    title: '字幕精灵 Pro',
    subtitle: 'AI 悬浮字幕翻译 · 全平台适配',
    tag: '140+ 语种 · 双向互译 · 悬浮显示 · 全平台覆盖',
    imageQuery: 'MossVox subtitle pro AI floating translation captions software on laptop screen, semitransparent subtitle bar displaying real time Chinese English bilingual translation during video conference call, 140 plus languages simultaneous interpretation, modern digital workspace setup, clean soft warm lighting, professional product screenshot aesthetic',
    imageSeq: 'subtitle-pro-banner',
  },
  overview: {
    title: '产品概述',
    content: '字幕精灵 Pro 是一款 AI 悬浮字幕翻译软件，可悬浮于任何应用之上，实时识别语音并翻译成目标语言字幕。深度适配 Zoom、Microsoft Teams、Google Meets、微信语聊、AirPods 通话等所有主流音视频平台，支持 140+ 语种单向及双向互译。无论是跨境视频会议、外语在线课程、跨国亲友通话，悬浮字幕都能让你的每一次对话可听可见。',
    imageQuery: 'Person attending international video conference using MossVox subtitle pro with floating translation captions visible on laptop screen, Chinese English bilingual subtitles overlay during Zoom meeting with foreign colleagues, modern home office setup with natural lighting, clean minimal workspace, professional work environment photography',
    imageSeq: 'subtitle-pro-overview',
  },
  platforms: {
    title: '全平台适配',
    subtitle: '一个软件，覆盖你所有的音视频场景',
    items: [
      {
        icon: 'ri-video-line', name: 'Zoom', desc: '完美适配Zoom会议，悬浮字幕不影响屏幕共享和参会体验',
        imageQuery: 'MossVox subtitle pro floating translation captions on Zoom video conference screen, multiple international participants visible, Chinese English bilingual subtitles overlay, modern UI integration, clean professional photography, soft lighting',
        imageSeq: 'sp-platform-1',
      },
      {
        icon: 'ri-team-line', name: 'Microsoft Teams', desc: 'Teams会议自动识别语音，实时双语字幕显示',
        imageQuery: 'MossVox subtitle pro running on Microsoft Teams meeting interface with real time bilingual subtitles, collaborative workspace with team chat visible, modern corporate communication platform, clean design, professional setting',
        imageSeq: 'sp-platform-2',
      },
      {
        icon: 'ri-google-line', name: 'Google Meets', desc: 'Google Meets全功能适配，支持多语种互译',
        imageQuery: 'MossVox subtitle pro floating translation captions on Google Meets video call, multilingual subtitle support with language selection dropdown, clean web app interface, minimalist design, professional setting',
        imageSeq: 'sp-platform-3',
      },
      {
        icon: 'ri-wechat-line', name: '微信语聊', desc: '微信语音通话、视频通话均可悬浮字幕翻译',
        imageQuery: 'Smartphone showing WeChat video call with MossVox subtitle pro floating translation captions overlay, Chinese English real time subtitles during mobile chat, social communication app integration, modern mobile interface, clean photography',
        imageSeq: 'sp-platform-4',
      },
      {
        icon: 'ri-headphone-line', name: 'AirPods 通话', desc: 'iPhone通话+AirPods场景，悬浮字幕显示对方说话内容',
        imageQuery: 'iPhone screen showing active call with MossVox subtitle pro translation captions floating overlay, AirPods wireless earbuds nearby, mobile phone call real time speech to text translation, clean product photography, modern tech accessories',
        imageSeq: 'sp-platform-5',
      },
      {
        icon: 'ri-smartphone-line', name: '更多平台', desc: '持续适配更多音视频平台，腾讯会议/钉钉/飞书等均支持',
        imageQuery: 'Collection of video conferencing app icons including Tencent Meeting DingTalk and Feishu with MossVox subtitle pro universal compatibility concept, all platforms supported by AI translation captions software, modern tech ecosystem, clean design, soft lighting',
        imageSeq: 'sp-platform-6',
      },
    ],
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-subtract-line', name: '悬浮字幕', desc: '半透明悬浮窗始终置顶于任何应用之上，不遮挡关键内容，阅读流畅。',
        imageQuery: 'MossVox subtitle pro semitransparent floating subtitle bar overlaid on top of various desktop applications, unobtrusive always on top caption design, real time speech to translated text display, clean modern interface, professional workspace, soft lighting',
        imageSeq: 'sp-feature-1',
      },
      {
        icon: 'ri-translate', name: '双向互译', desc: '你说中文对方看英文，对方说英文你看中文，对话自然双向实时翻译。',
        imageQuery: 'MossVox subtitle pro bidirectional translation visualization with arrow showing Chinese to English conversion and English to Chinese conversion simultaneously, dual direction real time speech translation concept, natural conversation flow diagram, clean graphic design, modern interface, soft lighting',
        imageSeq: 'sp-feature-2',
      },
      {
        icon: 'ri-global-line', name: '140+ 语种', desc: '覆盖全球主流语言，任意语种之间的单向及双向互译。',
        imageQuery: 'MossVox subtitle pro language selection panel showing 140 plus supported languages with world map background, global translation network visualization, multilingual caption support for any language pair, clean interface design, soft blue and warm accents',
        imageSeq: 'sp-feature-3',
      },
      {
        icon: 'ri-font-size', name: '字号可调', desc: '字幕字号、颜色、透明度、显示位置均可自由调节，适配不同视力需求。',
        imageQuery: 'MossVox subtitle pro text customization settings panel with font size slider color picker and opacity adjustment controls, subtitle position selector for top middle bottom of screen, accessibility features for different vision needs, modern settings UI, clean design, soft lighting',
        imageSeq: 'sp-feature-4',
      },
      {
        icon: 'ri-history-line', name: '字幕记录', desc: '对话记录自动保存为文本文件，会后可回溯查阅，不遗漏关键信息。',
        imageQuery: 'MossVox subtitle pro conversation history interface showing saved transcripts with timestamps and speaker labels, automatic recording of all translated conversations for later review, text log with search functionality, modern documentation tool, clean design, professional setting',
        imageSeq: 'sp-feature-5',
      },
      {
        icon: 'ri-download-line', name: '导出字幕', desc: '支持导出为SRT/TXT格式，可用于视频后期字幕制作或会议纪要整理。',
        imageQuery: 'MossVox subtitle pro export dialog showing SRT and TXT format options for subtitle export, file format selection for video post production or meeting minutes, modern software interface with download button, clean design, professional setting',
        imageSeq: 'sp-feature-6',
      },
    ],
  },
  scenarios: {
    title: '适用场景',
    items: [
      {
        icon: 'ri-video-chat-line', name: '跨境视频会议', desc: '跨国会议实时字幕翻译，双语显示确保所有参会者理解一致',
        imageQuery: 'MossVox subtitle pro providing real time bilingual translation captions during large international video conference, Chinese and English subtitles visible simultaneously, diverse multinational team on large screen, modern corporate meeting room, professional photography, clean lighting',
        imageSeq: 'sp-scenario-1',
      },
      {
        icon: 'ri-book-open-line', name: '外语在线课程', desc: 'Coursera/edX等海外课程实时英文字幕，辅助理解专业术语',
        imageQuery: 'MossVox subtitle pro floating English to Chinese translation captions over online course video from Coursera platform, educational video interface with real time subtitle translation, e-learning with AI language assistance, modern study setup with laptop, clean photography, bright academic lighting',
        imageSeq: 'sp-scenario-2',
      },
      {
        icon: 'ri-phone-line', name: '跨国亲友通话', desc: '与海外亲友通话时悬浮显示翻译字幕，亲情交流无障碍',
        imageQuery: 'Warm video call scene with MossVox subtitle pro floating translation captions during family chat across countries, Chinese English bilingual subtitles on screen, emotional international family connection, cozy home setting, clean photography, soft warm lighting',
        imageSeq: 'sp-scenario-3',
      },
      {
        icon: 'ri-live-line', name: '直播翻译', desc: '海外直播/发布会实时中文字幕，不错过任何精彩内容',
        imageQuery: 'MossVox subtitle pro providing real time Chinese translation captions during international live streaming event, product launch broadcast with AI subtitles overlay, digital media production scene, modern interface, clean professional photography, dynamic lighting',
        imageSeq: 'sp-scenario-4',
      },
    ],
  },
  cta: {
    primary: { text: '在线咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '免费体验', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
};

export const recorderData = {
  banner: {
    title: 'MossVox 录音牌',
    subtitle: 'AI 转写录音硬件 · 通话录音 + 自动转文字',
    tag: 'IP67防水 · 7m拾音 · 70天待机 · 20h连续录音 · 本地存储',
    imageQuery: 'MossVox compact voice recorder hardware device with sleek minimal design, IP67 waterproof AI speech to text recording gadget, 7 meter long range pickup 70 day standby 20 hour continuous recording, professional studio photography, warm cream background, modern clean product shot',
    imageSeq: 'recorder-banner',
  },
  overview: {
    title: '产品概述',
    content: 'MossVox 录音牌是新译科技专为通话转写设计的便携录音硬件。IP67 防水防尘等级，7 米远距离高保真拾音，70 天超长待机，20 小时连续录音能力。适配微信通话、WhatsApp、VoIP、LINE 等所有主流通话工具，录音文件自动 AI 转写为文字，并支持生成结构化发言稿。数据保存在设备本地存储，不经过云端服务器，确保通话内容的保密性和安全性。',
    imageQuery: 'Professional using MossVox compact voice recorder device next to smartphone during business call, AI speech to text transcription result displayed on phone screen, IP67 waterproof recording hardware for WeChat WhatsApp VoIP LINE calls, modern office desk setup, clean minimal photography, natural lighting, professional business setting',
    imageSeq: 'recorder-overview',
  },
  features: {
    title: '核心功能',
    items: [
      {
        icon: 'ri-shield-check-line', name: 'IP67 防水防尘', desc: '最高级别防护，雨天户外、厨房蒸汽、工地灰尘等恶劣环境均可正常使用。',
        imageQuery: 'MossVox recorder device splashed with water droplets demonstrating IP67 waterproof dustproof rating, highest level protection for outdoor rain kitchen steam construction site dust, rugged durable recording hardware, clean product photography, industrial aesthetic',
        imageSeq: 'rc-feature-1',
      },
      {
        icon: 'ri-mic-line', name: '7 米远距拾音', desc: '高灵敏度麦克风阵列，7米范围内清晰拾取人声，会议/采访场景不遗漏发言。',
        imageQuery: 'MossVox recorder device with sound wave radius diagram extending 7 meters for long range voice pickup, high sensitivity microphone array capturing clear human speech in meeting interview scenarios, distance measurement visualization, modern tech product, clean design, professional setting',
        imageSeq: 'rc-feature-2',
      },
      {
        icon: 'ri-battery-charge-line', name: '70 天待机', desc: '超低功耗设计，一次充电待机长达70天，20小时连续录音不断电。',
        imageQuery: 'MossVox recorder device battery indicator showing 70 day standby time, ultra low power consumption design, 20 hour continuous recording capability, long battery life recording gadget, modern tech product, clean product photography, soft lighting',
        imageSeq: 'rc-feature-3',
      },
      {
        icon: 'ri-file-text-line', name: 'AI 自动转写', desc: '录音完成后自动AI转写为文字，支持生成结构化发言稿，省去人工整理。',
        imageQuery: 'MossVox recorder device next to screen showing audio waveform transforming into structured text document, AI automatic speech to text transcription with speaker diarization, generated speech draft output, modern AI technology concept, clean interface design, professional setting',
        imageSeq: 'rc-feature-4',
      },
      {
        icon: 'ri-smartphone-line', name: '全通话适配', desc: '适配微信通话、WhatsApp、VoIP、LINE、普通电话等所有通话场景录音。',
        imageQuery: 'MossVox recorder device surrounded by WeChat WhatsApp VoIP LINE and regular phone call icons, universal compatibility with all calling apps and platforms, all communication tools supported for call recording, modern tech ecosystem, clean design, soft lighting',
        imageSeq: 'rc-feature-5',
      },
      {
        icon: 'ri-hard-drive-2-line', name: '本地安全存储', desc: '所有录音数据仅保存在设备本地，不上传云端，确保通话内容保密。',
        imageQuery: 'MossVox recorder device with lock icon and offline local storage indicator, no cloud upload secure privacy protection for call recordings, data stored only on device internal memory, privacy security concept, modern tech product, clean design, dark ambient',
        imageSeq: 'rc-feature-6',
      },
    ],
  },
  advantages: {
    title: '产品亮点',
    subtitle: '商务通话场景的录音转写利器',
    items: [
      { icon: 'ri-lock-line', name: '数据保密', desc: '本地存储不联网，商务谈判、法务咨询等敏感通话内容绝对安全' },
      { icon: 'ri-thunderstorms-line', name: '恶劣环境可用', desc: 'IP67级防护，无论工地巡检、户外采访、雨天出行均可靠运行' },
      { icon: 'ri-timer-line', name: '超长续航', desc: '70天待机+20小时录音，出差一周无需充电，重要通话不错过' },
      { icon: 'ri-brain-line', name: 'AI 发言稿', desc: '转写后自动生成结构化发言稿，商务汇报、会议纪要一键完成' },
    ],
  },
  specs: {
    title: '硬件规格参数',
    rows: [
      { label: '产品型号', value: 'MossVox Recorder / XY-R01' },
      { label: '防护等级', value: 'IP67 防水防尘' },
      { label: '拾音距离', value: '最远 7 米' },
      { label: '待机时间', value: '约 70 天' },
      { label: '连续录音', value: '约 20 小时' },
      { label: '存储容量', value: '16 GB 内置存储' },
      { label: '充电接口', value: 'Type-C' },
      { label: '适配通话', value: '微信/WhatsApp/VoIP/LINE/普通电话' },
      { label: '转写语种', value: '支持 140+ 语种' },
      { label: '输出格式', value: 'TXT / DOCX / SRT' },
      { label: '设备重量', value: '约 45 g' },
      { label: '尺寸', value: '68 × 38 × 12 mm' },
    ],
  },
  related: {
    title: '相关产品推荐',
    items: [
      {
        name: '字幕精灵 Pro',
        desc: 'AI悬浮字幕翻译软件，全平台视频会议字幕',
        href: '/mossvox/subtitle-pro',
        imageQuery: 'MossVox subtitle pro floating translation captions on laptop screen complementing recorder device, software plus hardware integrated solution for speech to text, modern workspace, clean tech aesthetic',
        imageSeq: 'related-subtitle-pro',
      },
    ],
  },
  cta: {
    primary: { text: '在线咨询', href: '#consultation' },
    secondary: { text: '下载产品白皮书', href: '/support/downloads' },
    tertiary: { text: '联系采购', href: '/contact' },
    jd: { text: '京东购买', href: 'https://shop.m.jd.com/shop/transition?shopId=13063638&utm_source=pdappwakeupup_20170002' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
};